import React from 'react';
import { NodeToolbar, Position } from 'reactflow';
import { useBoardComments } from './BoardCommentsContext';
import BoardCommentPin from './BoardCommentPin';
import BoardCommentThreadPanel from './BoardCommentThread';

interface BoardCommentAnchorProps {
  nodeId: string;
}

const BoardCommentAnchor: React.FC<BoardCommentAnchorProps> = ({ nodeId }) => {
  const { threadsByNodeId, expandedNodeId, openComments, closeComments, commentCount } =
    useBoardComments();

  const thread = threadsByNodeId.get(nodeId);
  const count = commentCount(nodeId);
  const expanded = expandedNodeId === nodeId;

  const toggle = () => {
    if (expanded) closeComments();
    else openComments(nodeId);
  };

  return (
    <>
      <BoardCommentPin nodeId={nodeId} count={count} expanded={expanded} onClick={toggle} />
      <NodeToolbar
        isVisible={expanded}
        position={Position.Right}
        offset={8}
        className="board-comment-toolbar"
      >
        <BoardCommentThreadPanel nodeId={nodeId} thread={thread} />
      </NodeToolbar>
    </>
  );
};

export default BoardCommentAnchor;
